import React from 'react'
import Home from '../../modules/Home'

const HomePage = () => {
  return <Home />
}

export default HomePage
